import { FC } from 'react';

import { WorkspaceFolderIcon } from '../../../../assets/icons/index';

type SpaceFolderIconProps = {
  className: string;
  // The Vault's Shared Folder, pink as on the Vault page.
  isShared?: boolean;
  size: number;
};

export const SpaceFolderIcon: FC<SpaceFolderIconProps> = ({
  className,
  isShared = false,
  size,
}) => (
  <WorkspaceFolderIcon
    className={className}
    height={size}
    iconColor={isShared ? '#FFB6E9' : undefined}
    shadowColor={isShared ? '#FF4DA8' : undefined}
    width={size}
  />
);
